import React, { useEffect } from "react";
import ContactListOfCompany from "../../pages/ContactListOfCompany";

export default function CompanyContacts({ activeWorkspace }) {
  // useEffect(() => {
  //   const handleMessageFromIframe = (event) => {
  //     console.log("event sidebar", event);
  //     // Optionally restrict origin
  //     if (event.data?.type === "CONTACT_LIST_EVENT") {
  //       // Relay to top window
  //       window.parent.postMessage(event.data, process.env.REACT_APP_BASE_URL);
  //     }
  //     if (event.data?.type === "CONTACTS_PUSHED_TO_CRM") {
  //       // Relay to top window
  //       window.parent.postMessage(event.data, process.env.REACT_APP_BASE_URL);
  //     }
  //   };

  //   window.addEventListener("message", handleMessageFromIframe);
  //   return () => window.removeEventListener("message", handleMessageFromIframe);
  // }, []);
  return (
    <div>
      {/* <iframe
        src={`${process.env.REACT_APP_BASE_URL}/app/${activeWorkspace?.slug}/company-contact-list`}
        className="w-full rounded-lg my-5 h-[70vh]"
      /> */}
      <ContactListOfCompany />
    </div>
  );
}
